module.exports = __webpack_public_path__ + "static/img/voided.b2bf37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/voided.png
// module id = tYMG
// module chunks = 6